'use client';

/**
 * SysObeyaKpiCapabilitiesCard — capability-scope KPI tile.
 *
 * Slices `response.totals.{total_stories, total_capabilities}` from
 * the system_obeya_view composite. Chrome (label, unit) comes from
 * `response.labels`. One of four tiles that replace the legacy
 * monolithic SysObeyaKpiStripCard.
 *
 * @see klyde_edge/ui_config/composition/cards/system_obeya.py — content_key="sys_obeya_kpi_capabilities"
 * @see klyde_edge/ui_config/labels/system_obeya.py — mod_sum_kpi_capabilities_*
 */

import { BookOpen } from 'lucide-react';
import { useSystemObeyaView } from './use-system-obeya-view';
import { KpiTile, fmt } from './kpi-tile';

interface Props {
  view_name?: string;
}

export function SysObeyaKpiCapabilitiesCard({ view_name = 'module_summary' }: Props) {
  const { data, isLoading, queryKey } = useSystemObeyaView(view_name);
  const L = data?.labels ?? {};
  const t = data?.totals ?? {};
  return (
    <KpiTile
      contentKey="sys_obeya_kpi_capabilities"
      label={L.mod_sum_kpi_capabilities_label ?? ''}
      Icon={BookOpen}
      value={isLoading ? '…' : fmt(t.total_stories)}
      sub={`${fmt(t.total_capabilities)} ${L.mod_sum_kpi_capabilities_unit ?? ''}`.trim()}
      queryKey={queryKey}
    />
  );
}
